<template>
  <div>
      <h3>{{name}}</h3>
      <div class="num">{{count}}</div>
      <button @click="increment">自增</button>
  </div>
</template>

<script>
export default {
  name: "test",
  props: {
    name: String,
    default: ""
  },
  data() {
    return {
      count: 0
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    increment() {
      this.count++;
    }
  }
};
</script>
<style lang='less' scoped>
</style>